import { Input as NUIInput } from "@nextui-org/input";
import { extendVariants } from "@nextui-org/system";

export const Input = extendVariants(NUIInput, {
  variants: {
    size: {
      sm: {
        inputWrapper: "rounded-sm",
      },
      md: {
        inputWrapper: "rounded-sm",
      },
      lg: {
        inputWrapper: "rounded-sm",
      },
    },
  },
  defaultVariants: {
    size: "md",
  },
});
